import React, { useState } from "react";
import _ from "lodash";
import { useNavigate } from "react-router-dom";
import BaseHeader from "@/components/Common/BaseHeader";
import Introductions from "@/components/HeaderButtons/Introductions";
import Notifications from "@/components/HeaderButtons/Notifications";
import DeleteNotificationModalNew from "@/components/Onboarding/DeleteNotificationModalNew";
import WantAdRenewConfirmationModal from "@/components/Onboarding/WantAdRenewConfirmationModal";
import { useUserDetails } from "@/context";
import { pageURLs } from "@/constants";
import Home from "@/images/v2/Home-icon.svg";
import Inventory from "@/images/v2/Inventory.svg";
import BellIcon from "@/images/v2/Bell-icon.svg";
import HandshakeIcon from "@/images/v2/Handshake-icon.svg";
import { BaseSidebarWrapper, HeaderSidebarBaseWrapper, SidebarItem } from "./HeaderSidebar";
import MobileBottomNav from "./MobileBottomNav";

const Sidebar = ({ currentURL, handleGoInventory, handleGoFeed, shouldToggleColor }) => {

  return (
    <BaseSidebarWrapper shouldToggleColor={shouldToggleColor}>
      <SidebarItem
        label="Feed"
        icon={Home}
        onClick={handleGoFeed}
        isActive={currentURL === "/" || currentURL === pageURLs.home}
      />

      <SidebarItem
        icon={Inventory}
        label={"My Inventory"}
        isActive={currentURL === pageURLs.consumerInventoryListing}
        onClick={handleGoInventory}
      />
    </BaseSidebarWrapper>
  );
};

const HeaderSidebarConsumer = React.forwardRef((allProps, headerRef) => {

  const {
    headerHeight,
    handleAgentOnboardingModal,
    handleGoFeed,
    user,
    currentURL,
    userPlan,
    showAgentMenuNotificationIcon,
    handleGoInventory,
    goTo,
    handleLogOut,
    introductionList,
    isLoadIntroList,
    unreadMessageCount,
    notificationList,
    isLoadNotificationList,
    unreadNotificationMessageCount,
    unreadInappNotificationCount,
    deleteNotificationModal,
    wantAdRenewModal,
    handleHandShakeClick,
    updateIntroStateonHover,
    updateIntroPageOnScroll,
    handleCloseIntroList,
    updateInAppStatusonHover,
    updateInAppDeleteStatusOnClick,
    renewWantAd,
    onDeleteInappNotification,
    onConfirmReniewWantAdClicked,
    handleDeleteNotificationPopupClose,
    handleWantAdRenewPopupClose,
  } = allProps;

  const [showBasicPlanModal, setBasicPlanModal] = useState(false);
  const [contactModalState, setContactModalState] = useState(false);

  const BasicPlanModalShow = () => setBasicPlanModal(true);
  const ContactModalShow = () => setContactModalState(true);

  const navigate = useNavigate();

  const userDetails = useUserDetails();

  const headerContent = HeaderSidebarBaseWrapper({
    ...allProps,
    sidebar: <Sidebar
      currentURL={currentURL}
      handleGoInventory={handleGoInventory}
      handleGoFeed={handleGoFeed}
      shouldToggleColor={userDetails?.shouldToggleColor}
    />,
    mobileNav: <MobileBottomNav
      leftItems={[
        { icon: Home, label: "Feed", onClick: handleGoFeed, isActive: currentURL === "/" || currentURL === pageURLs.home },
      ]}
      addMenuItems={[
        { icon: Inventory, label: "Property", onClick: handleGoInventory, isActive: currentURL === pageURLs.consumerInventoryListing },
      ]}
      notificationConfig={_.get(user, "userInfo", null) ? {
        icon: BellIcon,
        totalBadge: (unreadMessageCount || 0) + (unreadNotificationMessageCount || 0) + (unreadInappNotificationCount || 0),
        items: [
          {
            icon: HandshakeIcon,
            label: "Introductions",
            panelKey: "introductions",
            badge: unreadMessageCount || 0,
            onOpen: handleHandShakeClick,
          },
          {
            icon: BellIcon,
            label: "Notifications",
            panelKey: "notifications",
            badge: unreadNotificationMessageCount || unreadInappNotificationCount || 0,
            onOpen: updateInAppStatusonHover,
          },
        ],
        panels: {
          introductions: (
            <Introductions
              list={introductionList}
              updateIntroStateonHover={updateIntroStateonHover}
              updateIntroPageOnScroll={updateIntroPageOnScroll}
              isLoadIntroList={isLoadIntroList}
              handleCloseIntroList={handleCloseIntroList}
            />
          ),
          notifications: (
            <div className="w-100 h-100 position-relative notif-modal-container">
              <Notifications
                list={notificationList}
                isLoadNotificationList={isLoadNotificationList}
                onDeleteInappNotification={() => onDeleteInappNotification()}
                updateInAppDeleteStatusOnClick={updateInAppDeleteStatusOnClick}
                renewWantAd={(notification) => renewWantAd(notification)}
              />
              <DeleteNotificationModalNew
                show={deleteNotificationModal}
                onHide={handleDeleteNotificationPopupClose}
                onConfirm={updateInAppDeleteStatusOnClick}
              />
              <WantAdRenewConfirmationModal
                show={wantAdRenewModal}
                onHide={handleWantAdRenewPopupClose}
                onConfirmReniewWantAd={onConfirmReniewWantAdClicked}
              />
            </div>
          ),
        },
      } : null}
    />,
    authButtonsProps: {
      handleAgentOnboardingModal,
    },
    headerSidebarDropdownMenuProps: {
      user,
      userDetails,
      userPlan,
      showAgentMenuNotificationIcon,
      navigate,
      BasicPlanModalShow,
      ContactModalShow,
      handleLogOut,
    }
  })

  return (
    <BaseHeader
      {...allProps}
      headerContent={headerContent}
    />
  );
});

export default HeaderSidebarConsumer;
